import { render, staticRenderFns } from "./BulkActions.vue?vue&type=template&id=62b8046c&scoped=true&"
import script from "./BulkActions.vue?vue&type=script&lang=js&"
export * from "./BulkActions.vue?vue&type=script&lang=js&"
import style0 from "./BulkActions.vue?vue&type=style&index=0&id=62b8046c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b8046c",
  null
  
)

export default component.exports